<div class="flex flex-wrap no-row-gap decreased-margin" *ngIf="period?.start" [ngClass]="{'flex-end': alignRight}">
  <ng-container *ngIf="!isPeriodSameDay">
    <div class="flex decreased-margin">
      <div class="info-prop">
        <mat-icon class="svg-icon" [svgIcon]="icon" [matTooltip]="iconTooltip?.length ? (iconTooltip | translate) : null"></mat-icon>
        <span>{{ period.start | moment: { tz: timezone } }}</span>
      </div>
      <div class="info-prop">
        <span>{{ period.start | moment: { format: viewService.conf.timeFormat, tz: timezone } }}</span>
      </div>
    </div>
    <ng-container *ngIf="period?.end">
      <div class="info-prop">
        <span>-</span>
      </div>
      <div class="flex decreased-margin">
        <div class="info-prop">
          <span>{{ period.end | moment: { tz: timezone } }}</span>
        </div>
        <div class="info-prop">
          <span>{{ period.end | moment: { format: viewService.conf.timeFormat, tz: timezone } }}</span>
        </div>
      </div>
    </ng-container>
  </ng-container>
  <div class="flex decreased-margin" *ngIf="isPeriodSameDay">
    <div class="info-prop">
      <mat-icon class="svg-icon" [svgIcon]="icon" [matTooltip]="iconTooltip?.length ? (iconTooltip | translate) : null"></mat-icon>
      <span>{{ period.start | moment: { tz: timezone } }}</span>
    </div>
    <div class="info-prop">
      <span>
        {{ period.start | moment: { format: viewService.conf.timeFormat, tz: timezone } }}
        <ng-container *ngIf="period?.end"> - {{ period.end | moment: { format: viewService.conf.timeFormat, tz: timezone } }}</ng-container>
      </span>
    </div>
  </div>
</div>
